
































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Transporteur} from '@/models';

import CrudTransporteurShow from '@/components/Crud/Transporteur/Show.vue';

@Component({
	components: {
		CrudTransporteurShow,
	}
})
export default class CrudTransporteurShowDialog extends Vue {
	@InOut({ type: Transporteur  , isVModel: true }) private value!: Transporteur;
	
	@Emit()
	public onClose() {
		this.value = null;
	}
}
